<template>
  <div class="over-view">
    <div class="alert-box">
      <div class="activeTime flex-box flex-hv-c">
        活动时间:{{ $store.state.userMsg.userMsg.fangkaStoreActivity.startTime | formatDateExp('yyyy.MM.dd') }} -
        {{ $store.state.userMsg.userMsg.fangkaStoreActivity.endTime | formatDateExp('yyyy.MM.dd') }}
      </div>
      <span class="close-btn" @click="closeView">
        <img src="http://image.shrongyikeji.com/manager/diamonMall/close.png" alt />
      </span>
      <p class="con-box" @click="goToMall">
        <img src="http://image.shrongyikeji.com/manager/diamonMall/alert.png?a=1" alt />
      </p>
      <p class="link-btn" @click="goToMall">
        <img src="http://image.shrongyikeji.com/manager/diamonMall/coming.png" alt />
      </p>
      <div class="leftTxt">距离活动结束还剩</div>
      <div class="cutTime flex-box flex-hv-c" v-html="timerHtml"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'diamondWarn',
  data() {
    return {
      timerHtml: ""
    }
  },
  methods: {
    closeView() {
      this.$emit("closeView");
    },
    goToMall() {
      this.$emit("closeView");
      location.href = './active/diamondMall.html?managerId=' + this.$store.state.userMsg.userMsg.managerId + '&token=' + localStorage.getItem('token')
    },
    timer: function (endTimer) {
      var that = this
      var ts = endTimer
      if (ts > 0) {
        var dd = parseInt(ts / 1000 / 60 / 60 / 24, 10)
        var hh = parseInt((ts / 1000 / 60 / 60) % 24, 10)
        var mm = parseInt((ts / 1000 / 60) % 60, 10)
        var ss = parseInt((ts / 1000) % 60, 10)
        dd = dd < 10 ? '0' + dd : dd //天
        hh = hh < 10 ? '0' + hh : hh //时
        mm = mm < 10 ? '0' + mm : mm //分
        ss = ss < 10 ? '0' + ss : ss //
        var d1 = dd.toString().substring(0, 1)
        var d2 = dd.toString().substring(1)
        var h1 = hh.toString().substring(0, 1)
        var h2 = hh.toString().substring(1)
        var m1 = mm.toString().substring(0, 1)
        var m2 = mm.toString().substring(1)
        var s1 = ss.toString().substring(0, 1)
        var s2 = ss.toString().substring(1)
        that.timerHtml =
          '<span class="leftTime"><span> ' +
          d1 +
          '</span><span>' +
          d2 +
          '</span>天 <span> ' +
          h1 +
          '</span><span>' +
          h2 +
          '</span>: <span>' +
          m1 +
          '</span><span>' +
          m2 +
          '</span>: <span>' +
          s1 +
          '</span><span>' +
          s2 +
          '</span></span>'
        setTimeout(function () {
          that.timer(ts - 1000)
        }, 1000)
      } else {
        if (that.$store.state.userMsg.userMsg.serverTime > that.$store.state.userMsg.userMsg.fangkaStoreActivity.endTime) {
          that.timerHtml = '<span class="leftTime">活动已结束<span>'
        }
      }
    }
  },
  created() {
    if (this.$store.state.userMsg.userMsg.fangkaStoreActivity) {
      var cutTime = this.$store.state.userMsg.userMsg.fangkaStoreActivity.endTime - this.$store.state.userMsg.userMsg.serverTime
      this.timer(cutTime)
    }
  }
}
</script>
<style lang="">
.over-view {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 100;
}
.alert-box {
  position: relative;
  width: 100%;
  margin: 0 auto;
}
.close-btn {
  width: 0.8rem;
  height: 0.8rem;
  position: absolute;
  right: 0.2rem;
  top: 1rem;
  z-index: 101;
}
.close-btn img {
  width: 100%;
  height: 100%;
}
.con-box {
  width: 100%;
  margin: 0 auto;
}
.con-box img {
  width: 100%;
  height: 100%;
}
.link-btn {
  margin: 0 auto;
  width: 3.32rem;
  height: 0.87rem;
}
.link-btn img {
  width: 100%;
  height: 100%;
}
.cutTime {
  position: absolute;
  top: 75%;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 24px;
  color: #fff;
}
.activeTime {
  position: absolute;
  width: 5.5rem;
  height: 0.6rem;
  top: 35%;
  left: 50%;
  color: #dae976;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 4px) rotate(-4.5deg);
  font-size: 13px;
}
.leftTxt {
  position: absolute;
  top: 71%;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  font-size: 16px;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/home/alert/diamondMall.vue